import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledTopBarNewComponent = styled.div`
  .top-bar-mobile-wrapper {
    display: none;
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .top-bar-desktop-wrapper {
      display: none;
    }

    .top-bar-mobile-wrapper {
      display: block;
    }
  }
`;
